import type { Observable } from 'rxjs';

import { IdentityUnavailableError } from './light-http.service';
import type { ToastHandle } from './toast.service';

export interface IdentityNoticeDeps {
    uiContext: { noticeWithAction(title: string, message: string, actionLabel: string, onAction: (ref: ToastHandle) => void): void };
    loginService: { retryIdentityOnce(): Observable<unknown> };
}

export const IDENTITY_NOTICE_TAIL = 'Downloading your finished files still works; only a ZIP needs this.';

/**
 * F3r (review 7, F3p forced-429 check): the anonymous sign-in gave up on 429. That used to be `_app.tsx`'s one error
 * DIALOG with a lone Retry -- over the page, so the finished files (which need no identity) could not be downloaded, and
 * Retry re-sent the login at once, got 429 again and re-opened the dialog. Now it is a non-blocking notice: the page
 * stays usable, only identity-bound actions (bulk ZIP, `IDENTITY_BOUND_URL`) fail, with this same error at their own
 * button. Retry waits out the server's Retry-After and tries ONCE (`LoginService.retryIdentityOnce`); still limited ->
 * this notice again, never a dialog.
 */
export function noticeIdentityUnavailable(deps: IdentityNoticeDeps, err: IdentityUnavailableError): void {
    deps.uiContext.noticeWithAction(err.name, `${err.message} ${IDENTITY_NOTICE_TAIL}`, 'Retry', (ref) => {
        ref.unmount();
        deps.loginService.retryIdentityOnce().subscribe({
            error: (e) => { if (e instanceof IdentityUnavailableError) noticeIdentityUnavailable(deps, e); },
        });
    });
}
